import {
    Button,
    ButtonSize,
    ColourSolid,
    DropdownMenu, FlexAlign, FlexGap, ItemMenuEntry, ItemRow, Pill,
    PillSize,
    StackHorizontal, ToggleSwitch,
    ToggleType, Tooltip,
    useLayout
} from "@twigsby/frontend-framework";
import React from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCrown} from "@fortawesome/pro-solid-svg-icons/faCrown";
import {faEnvelope} from "@fortawesome/pro-solid-svg-icons/faEnvelope";
import {faKey} from "@fortawesome/pro-solid-svg-icons/faKey";
import {faTrash} from "@fortawesome/pro-solid-svg-icons/faTrash";
import {faUser} from "@fortawesome/pro-solid-svg-icons/faUser";
import {faWavePulse} from "@fortawesome/pro-solid-svg-icons/faWavePulse";
import {faCogs} from "@fortawesome/pro-light-svg-icons/faCogs";
import {useAccountUser, UserDataType } from "@twigsby/client-data";
import {useTranslation} from "@twigsby/frontend-framework";

interface UserEntryType extends UserDataType {
    passwordResetCallback: any;
    deleteCallback: any;
    disableCallback: any;
}

const SendsUserItem = (props: UserEntryType) => {
    const { t } = useTranslation();
    const { isMedium, isXL } = useLayout();
    const { data } = useAccountUser();

    const userRole = props?.roles.includes('SENDS_PAGE_ADMIN') ? 'Admin' : props?.roles.includes('MANAGER') ? 'Manager' : 'User';

    return (
        <ItemRow static={true}>
            {isMedium ? (
                <>
                    <StackHorizontal gap={FlexGap.ExtraSmall} align={FlexAlign.Center} extraClass={'pl-lg'}>
                        <Tooltip content={userRole}>
                            {userRole === 'User' ? (
                                <Pill size={PillSize.Large} content={<FontAwesomeIcon icon={faUser} fixedWidth={true} />} overflow={true} />
                            ) : (
                                <Pill size={PillSize.Large} colour={userRole === 'Admin' ? ColourSolid.Success : ColourSolid.Secondary} content={<FontAwesomeIcon icon={faCrown} fixedWidth={true} />} overflow={true} />
                            )}
                        </Tooltip>
                        {props.name}
                    </StackHorizontal>
                    <div>{props.userName}</div>
                    {data?.emailAddress !== props.userName && (
                        <>
                            <StackHorizontal gap={FlexGap.ExtraSmall}>
                                <Button onClick={() => props.passwordResetCallback()} title={t('sends.users.actions.passwordReset')} squared={true} size={ButtonSize.Small} colour={ColourSolid.Primary} iconOnly={!isXL} icon={faEnvelope}  />
                                <Button onClick={() => props.deleteCallback()} title={t('sends.users.actions.delete')} squared={true} size={ButtonSize.Small} iconOnly={!isXL} icon={faTrash}  />
                            </StackHorizontal>
                            <div>
                                <ToggleSwitch type={ToggleType.Switch} hideLabel={true} name={`user${props.userId}`} label={t('status.active')} defaultChecked={!props.isDisabled} onChange={(e: any) => props.disableCallback(!e.currentTarget.checked)} />
                            </div>
                        </>
                    )}
                </>
            ) : (
                <>
                    <div>
                        <h5 className={'m-0'}>{props.name}</h5>
                        {props.userName}
                    </div>
                    {data?.emailAddress !== props.userName && (
                        <div>
                            <DropdownMenu
                                trigger={
                                    <Button title={t("actions.title")} squared={true} icon={faCogs} iconOnly={true} onClick={() => null}/>
                                }
                            >
                                <ItemMenuEntry
                                    title={t("sends.users.actions.passwordReset")}
                                    onClick={() => props.passwordResetCallback()}
                                    icon={faKey}
                                />

                                <ItemMenuEntry
                                    title={t("isActive")}
                                    icon={faWavePulse}
                                    onClick={(e: any) => props.disableCallback(!e.currentTarget.checked)}
                                    addonContent={
                                        <ToggleSwitch type={ToggleType.Switch} hideLabel={true} label={t("status.active")} name={`user${props.userId}`} defaultChecked={props.isDisabled} />
                                    }
                                />

                                <ItemMenuEntry title={t("divider")} sectionDivider={true} />


                                <ItemMenuEntry
                                    title={t("sends.users.actions.delete")}
                                    onClick={() => props.deleteCallback()}
                                    icon={faTrash}
                                />
                            </DropdownMenu>
                        </div>
                    )}
                </>
            )}
        </ItemRow>
    )
}

export default SendsUserItem
